import { ButtonOverlay, TableButton } from "medere-ui-framework";
import { Button } from "primereact/button";
import { useRef } from "react";
import "./LocationActionMenu.scss";

export interface LocationActionItem {
    label: string;
    icon: string;
    action: () => void;
    disabled?: boolean;
}

interface LocationActionMenuProps {
    items: LocationActionItem[];
    buttonClassName?: string;
    ariaLabel?: string;
    panelClassName?: string;
    contentClassName?: string;
    buttonId?: string;
    buttonDisabled?: boolean;
}

function normalizeTableButtonIcon(icon: string) {
    return String(icon ?? "").replace(/^pi\s+/, "");
}

export default function LocationActionMenu({
    items,
    buttonClassName = "p-button-text",
    ariaLabel = "Opciones",
    panelClassName = "location-mobile-action-menu-panel",
    contentClassName = "w-64",
    buttonId,
    buttonDisabled = false,
}: Readonly<LocationActionMenuProps>) {
    const overlayRef = useRef<any>(null);
    const visibleItems = (items ?? []).filter((item) => !item.disabled);

    if (visibleItems.length === 0) return null;

    return (
        <ButtonOverlay
            ref={overlayRef}
            className={panelClassName}
            contentClassName={contentClassName}
            buttonClassName={buttonClassName}
            button={({ buttonClassName: resolvedClassName, disabled, rounded, visible, onClick }) => (
                <Button
                    id={buttonId}
                    icon="pi pi-ellipsis-v"
                    className={resolvedClassName}
                    disabled={disabled || buttonDisabled}
                    rounded={rounded}
                    visible={visible}
                    onClick={onClick}
                    aria-label={ariaLabel}
                />
            )}
        >
            <div className="flex flex-column location-action-menu-items">
                {visibleItems.map((item, index) => (
                    <TableButton
                        key={`${item.label}-${index}`}
                        label={item.label}
                        icon={normalizeTableButtonIcon(item.icon)}
                        iconPos="left"
                        onClick={() => {
                            item.action();
                            overlayRef.current?.hide?.();
                        }}
                        className={`text-left TableButtonStyle text-sm p-1 location-action-menu-item ${index > 0 ? "location-action-menu-item--with-divider" : ""}`}
                    />
                ))}
            </div>
        </ButtonOverlay>
    );
}
